import { useTranslation } from 'react-i18next';
import DocumentoLegal from '../components/DocumentoLegal';
import es from '../legal/terminos.es';
import en from '../legal/terminos.en';

export default function Terminos() {
    const { i18n } = useTranslation();
    return <DocumentoLegal documento={i18n.language?.startsWith('es') ? es : en} />;
}
